import { create } from '~/utils/store/createStore';

interface ChatInputState {
  hasUserInteracted: boolean;
  askedQuestions: string[];
  setHasUserInteracted: (value: boolean) => void;
  addNewAskedQuestion: (value: string) => void;
}

export const useChatInputStore = create<ChatInputState>(set => ({
  hasUserInteracted: false,
  askedQuestions: [],
  setHasUserInteracted: (value: boolean) => set({ hasUserInteracted: value }),
  addNewAskedQuestion: (value: string) =>
    set(state => ({ askedQuestions: [...state.askedQuestions, value] })),
}));
